import { CheckCircleIcon, EmailIcon } from '@chakra-ui/icons'
import { Box, Flex, Text } from '@chakra-ui/react'
import { getDateTimeString, PracticeContract, WithId } from '@hb/shared'
import { ActionButton, SolidActionButton } from '../../Buttons/ActionButton'
import { DeletePracticeContractButton } from './DeletePracticeContract'

export const PracticeContractStatusView = ({
  contract,
  handleViewContract,
  adminView,
  signerLabel,
}: {
  contract: WithId<PracticeContract>
  handleViewContract?: (contractId: string) => void
  adminView?: boolean
  signerLabel?: string
}) => {
  const ButtonComponent = contract.signedOn ? ActionButton : SolidActionButton
  return (
    <Flex w="100%" gap={2} flexFlow={['column', 'column', 'row']} justifyContent="space-between">
      <Box py={2} px={4} flex={1} minW="0">
        <Text fontSize="lg" fontWeight={500}>
          {contract.name}
        </Text>
        <Flex align="center" gap={1.5}>
          <EmailIcon w={4} h={4} opacity={0.7} />
          <Text fontWeight={500} color="gray.500">
            SENT {getDateTimeString(contract.sentOn, 'short')}
            {signerLabel ? ` TO ${signerLabel.toUpperCase()}` : ''}
          </Text>
        </Flex>
        <Flex align="center" gap={1.5}>
          <CheckCircleIcon
            w={4}
            h={4}
            color={contract.signedOn ? 'green.500' : 'blackAlpha.500'}
            _dark={{ color: contract.signedOn ? 'green.400' : 'gray.400' }}
          />
          <Text
            fontWeight={500}
            color={contract.signedOn ? 'green.500' : 'gray.500'}
            _dark={{ color: contract.signedOn ? 'green.400' : 'gray.400' }}>
            {contract.signedOn
              ? `SIGNED ${getDateTimeString(contract.signedOn, 'short')}`
              : 'NOT SIGNED'}
          </Text>
        </Flex>
      </Box>
      <Flex
        justifyContent={adminView ? 'flex-start' : 'center'}
        alignItems="flex-end"
        pb={1}
        pt={3}
        pr={3}
        flexFlow="column"
        gap={2}>
        {handleViewContract ? (
          <ButtonComponent
            size="sm"
            w={['100%', '100%', 'auto']}
            onClick={() => handleViewContract(contract.id)}
            variant={contract.signedOn ? 'outline' : 'solid'}>
            {contract.signedOn ? 'View Signed Contract' : 'View Contract'}
          </ButtonComponent>
        ) : null}
        {adminView ? <DeletePracticeContractButton contract={contract} /> : null}
      </Flex>
    </Flex>
  )
}
